import {Component, enableProdMode, NgZone} from '@angular/core';
import {AppSettings} from "./appSettings";
import {ContentProvider} from "../providers/content-provider/content-provider";
import {Patient} from "../providers/content-provider/data-objects";
import * as moment from "moment";
import "moment/locale/de";
import {
  AlertController,
  MenuController,
  ModalController,
  NavController,
  Platform,
  ToastController
} from '@ionic/angular';
import {Events} from 'src/providers/eventService/events';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {ThemeService} from './theme.service';
//import {AppRate, AppRateReviewTypeIos} from '@awesome-cordova-plugins/app-rate/ngx';
import {App, URLOpenListener, URLOpenListenerEvent} from "@capacitor/app";
import { environment } from 'src/environments/environment';
import { SplashScreen } from '@capacitor/splash-screen';
//import { RateApp } from 'capacitor-rate-app';


@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  AppSettings = AppSettings;
  DEBUG = AppSettings.DEBUG;
  TAG = "MyApp";
  // THEME COLORS
  public themeColor = [
    { name: 'Default', class: 'default' },
    { name: 'Dark', class: 'dark' }
  ];
  public selectTheme;

  dark = false;
  public rootPage: any = AppSettings.STARTSEITE;
  pages: Array<{ title: string, component: any, command: number, icon: string, separate: boolean, onlyInWeb: boolean, href: string }>;
  pagesLoggedIn: Array<{ title: string, component: any, command: number, icon: string, separate: boolean, onlyInWeb: boolean, href: string }>;
  pagesList: Array<{ title: string, component: any, command: number, icon: string, showAsGuest: boolean, showAsPatient: boolean, showAsDoc: Boolean, separate: boolean, onlyInWeb: boolean, href: string }>;

  public pagesPatient: Array<{
    title: string;
    component: any;
    command: number;
    icon: string;
    showOnLogin: boolean;
    showAsGuest: boolean;
    hideAsDoc: boolean;
    separate: boolean;
    onlyInWeb: boolean;
    href: string;
  }>;

  public pagesFootage: Array<{
    title: string;
    command: number;
    icon: string;
    separate: boolean;
    onlyInWeb: boolean;
    href: string;
  }>;
  public pagesLegals: Array<{
    title: string;
    component: any;
    command: number;
    icon: string;
    separate: boolean;
    onlyInWeb: boolean;
    href: string;
  }>;

  public docLogin: boolean = false;
  public netLogin: boolean = false;
  public patLogin: boolean = false;

  public patislogin: boolean = false;

  public roleSettings;
  public roleid;
  public roles = [];
  public rolekeys;


  showTabs: boolean = false;

  //pushObj: PushObject;
  lastPush: string = "";
  sideIntent: any = null;
  userInfo: Patient = new Patient();
  unreadCount: number = 0;
  backClicks: number = 0;
  docPack: number = 0;
  loggedIn: boolean;
  public isMobile = false;
  public isDesktop = false;
  stringInCode: string;
  stringInButton: string;
  renderer: any;

  constructor(
    public platform: Platform,
    public menu: MenuController,
    public cp: ContentProvider,
    public events: Events,
    public toastController: ToastController,
    private modalCtrl: ModalController,
    public navCtrl: NavController,
    private router: Router,
    private alertCtrl: AlertController,
    private translate: TranslateService,
    private theme: ThemeService,
   // private appRate: AppRate,
    private zone:NgZone
  ) {
    this.selectTheme = 'default';
    this.dynamicTheme();
    this.cp.accMngerPatient.isLoggedIn().subscribe((loggedIn) => {});
    if (this.platform.width() < 800) {
      this.isMobile = true;
    } else {
      this.isDesktop = true;
    }

    this.showSplash();

    if (this.DEBUG == false) {
      enableProdMode();
    }

    this.initializeTranslateServiceConfig();
    this.initApp();

    this.translate.addLangs(['de', 'en']);
    this.translate.setDefaultLang("de");
    this.translate.use(AppSettings.getLanguage());

    this.pagesPatient = AppSettings.PATPAGES_LIST;
    this.pagesLegals = AppSettings.FOOTAGE_LEGALS;
    //Todo if environment app change the Footage_pages
    //console.log('ENVIRONMENT app.component', environment)
    if(!environment.apptemp){
      this.pagesFootage = AppSettings.FOOTAGE_PAGES;
    } else {
      this.pagesFootage = AppSettings.FOOTAGE_PAGES_APP;
    }


    this.events.subscribe("langChangeDe", () => {
      this.translateLanguageTo("de");
    });
    this.events.subscribe("langChangeEn", () => {
      this.translateLanguageTo("en");
    });
    this.events.subscribe("logout", () => {
      this.logout();
      this.patLogin = false;
    });
    this.events.subscribe("login", () => {
      this.setMenuLoggedIn();
      //this.registerPush();
      this.patislogin = true;
      this.patLogin = true;
    });
    this.events.subscribe("refresh", () => {
      this.cp.getPatientData("patient", true).subscribe(
        (data) => {
          if (this.DEBUG)
            console.log(this.TAG, "loadPatient", "getPatient", data);
          this.userInfo = data;
        },
        (error) => { }
      );
      this.setMessageCount();
    });
    this.events.subscribe("refreshDoc", () => { });
    this.setMenuLoggedOut();

    this.initMomentJS();

    if (this.cp.accMngerPatient.loggedIn) {
      this.patislogin = true;
      if (this.DEBUG) console.log('PATIENT is logged in');
    }


  }

  async showSplash(){
    await SplashScreen.show({
      showDuration: 1000,
      autoHide: true,
    });
  }

 /* promptRating(){
    this.appRate.promptForRating(true);
  }*/
  hiddenNavElement(p, navID): boolean {
    var hidden = false;
    // console.log("Hide Page", p.title)
    switch (navID) {
      case 1: // Patient
        if (this.cp.accMngerPatient.loggedIn && !p.showOnLogin) hidden = true;
        if (!this.cp.accMngerPatient.loggedIn && !p.showAsGuest) hidden = true;
        break;
      case 2: // footage, always show, except web only
        hidden = false;
    }

    // hide if only in web
    hidden =
      hidden ||
      (p.onlyInWeb &&
        !(this.platform.is("desktop") || this.platform.is("tablet")));
    // console.log("final hidden prop:", p, hidden);
    if (hidden == false) {
      // this.buildRouter(p, navID);
    }

    return hidden;
  }

  initMomentJS(): void {
    moment.locale("de");
  }

  setMenuLoggedIn(): void {
    if (this.DEBUG) console.log(this.TAG, "setMenuLoggedIn");
    this.menu.enable(true, "menu-logged-in");
    this.menu.enable(false, "menu-logged-out");
    //Todo Tabed Menu visible
  }

  setMenuLoggedOut(): void {
    if (this.DEBUG) console.log(this.TAG, "setMenuLoggedOut");
    this.menu.enable(true, "menu-logged-out");
    this.menu.enable(false, "menu-logged-in");
  }

  toggleMenu(): void {
    this.menu.enable(false, "menuLeft");
    this.menu.enable(true, "menuLeft");
  }

  setMessageCount() {
    this.cp.getMessages(true).subscribe(
      (msgs) => {
        this.unreadCount = 0;
        for (var t = 0; t < msgs.length; ++t) {
          if (!msgs[t].seen) {
            this.unreadCount++;
          }
        }
        //this.badge.set(this.unreadCount);
      },
      (error) => {
        //this.badge.clear();
      }
    );
  }

  initApp() {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      this.zone.run(() => {
        const slug = event.url.split(".de").pop();
        if (slug) {
          this.router.navigateByUrl(slug);
        }
      });
    });

    //this.rootPage = 'SearchPage';
    this.platform.ready().then((readySource) => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.setMessageCount();
      this.translate.setDefaultLang('de');

      //this.statusBar.styleDefault();
      // StatusBar.backgroundColorByHexString('#00b6e8');
      if (readySource != "dom") {
        this.initPush();
        //this.registerPush();
      }

      let mtEnde = 1566633600;
      this.cp.showMaintainance().then((mt) => {
        if ((mt == null || !mt.seen) && mtEnde > this.cp.getCurTS()) {
          if (this.DEBUG) console.log("show maintance alert.");
          /*
          this.alertHandler.showAlert(
            "Wartungsarbeiten",
            "Am Freitag, 23.08, finden von 22:00 Uhr bis vorraussichtlich Samstag, 24.08, 10:00 Uhr Wartungsarbeiten an der Server-Infrastruktur statt. Während dieser Zeit wird unser Service nicht erreichbar sein. Vielen Dank für Ihr Verständnis!",
            () => {
              this.cp.setMaintainance(0, 0, true);
            }
          );*/
        }
      });
    });

    this.cp.accMngerPatient.isLoggedIn().subscribe((loggedIn) => {
      if (loggedIn) {
        // this.setMenuLoggedIn();
        // this.loggedIn = true;
        if (this.DEBUG) console.log("PatientLoggedIn");
        this.patislogin = true;

        if (!(this.platform.is("desktop") || this.platform.is("mobileweb"))) {
          this.rootPage.insert(1, "dashboard").then(() => {
            if (this.sideIntent != null) {
              this.navCtrl.navigateForward(this.sideIntent[0], this.sideIntent[1]);
            }
          });
        } else {
          if (this.sideIntent != null) {
            this.navCtrl.navigateForward(this.sideIntent[0], this.sideIntent[1]);
          }
        }

        this.cp.getPatientData("patient", true).subscribe(
          (data) => {
            if (this.DEBUG)
              console.log(this.TAG, "loadPatient", "getPatient", data);
            this.userInfo = data;
          },
          (error) => { }
        );
      } // LoggedIn Patient
      else {

      }
    });
    this.platform.ready().then(() => {
      document.addEventListener("backbutton", () => {
        if (this.rootPage.canGoBack()) {
          //Todo update what parameteres in navigate back
          //this.navCtrl.navigateBack();
        } else {
          if (this.backClicks == 0) {
            this.backClicks++;
            //this.presentToast("errors.exit_app.message");

            setTimeout(() => {
              this.backClicks = 0;
            }, 1500);
          } else {
            //Todo update
            //this.platform.exitApp();
          }
        }
      });
    });

    //RateApp.requestReview();

    //console.log('VOR APPRATE');
    /*
    this.appRate.setPreferences({
      displayAppName: 'TerMed',
      promptAgainForEachNewVersion: true,
      usesUntilPrompt: 3,
      showPromptForInAppReview: true,
      customLocale: {
        title: "Würden Sie uns gerne bewerten?",
        message: "Es dauert weniger als eine Minute.",
        cancelButtonLabel: "Nein, Danke",
        laterButtonLabel: "Erinnere mich später",
        rateButtonLabel: "Jetzt bewerten",
        yesButtonLabel: "Ja!",
        noButtonLabel: "Nicht wirklich",
        appRatePromptTitle: 'Gefällt dir TerMed',
        feedbackPromptTitle: 'Würdest du uns eine kurze Rückmeldung geben?',
      },
      storeAppURL: {
        ios: '1176344732',
        android: 'market://details?id=de.appsmadeingermany.facharzt_sofort',
        //blackberry: 'appworld://content/[App Id]/',
        //windows8: 'ms-windows-store:Review?name=<the Package Family Name of the application>'
      },
      reviewType: {
        ios: AppRateReviewTypeIos.AppStoreReview
      },
      callbacks: {
        handleNegativeFeedback: function(){
          console.log('handlenegativefeedback');
          window.open('mailto:info@termed.de', '_system');
        },
        onRateDialogShow: function(callback){
          callback(3) // cause immediate click on 'Rate Now' button
        },
        onButtonClicked: function(buttonIndex){
          console.log("onButtonClicked -> " + buttonIndex);
        }
      },
      openUrl: function(url){
        console.log('openUrl', url);
        window.open(url, '_blank', 'location=yes');
      }
    });
    this.appRate.promptForRating(false);
*/
  }





  initPush() {
    if (this.DEBUG) console.log(this.TAG, "initPush");
    /*
    const options: PushOptions = {
      android: {
        senderID: AppSettings.FCM_SENDER_ID,
      },
      ios: {
        alert: "true",
        //badge: false,
        sound: "true",
      },
      windows: {},
      browser: {},
    };*/
    // this.pushObj = this.push.init(options);
  }


  logout() {
    if (this.DEBUG) console.log(this.TAG, "logout");
    this.setMenuLoggedOut();
    this.navCtrl.navigateForward('start');
    //this.navCtrl.navigateForward('login');

  }


  initializeTranslateServiceConfig() {
    var userLang = "de";
    if (navigator.language) {
      userLang = navigator.language.split("-")[0];
    }
    userLang = /(de)/gi.test(userLang) ? userLang : "de";

    //this.translate.setDefaultLang("de");

    //this.translate.use(userLang);
  }


  goToRoot(event = null) {
    if (event != null) {
      event.preventDefault();
      event.stopPropagation();
    }
    // if (this.nav.getActive().component != undefined && this.nav.getActive().component != this.rootPage) {
    if (this.rootPage.canGoBack()) {
      this.rootPage.popToRoot();
    }
  }

  openStart() {
    this.navCtrl.navigateForward('/start');
    this.menu.close();
  }

  openPage(event, page) {
    if (this.DEBUG) console.log('OPEN PAGE', event, page);
    if (page.children.length > 0) {
      page.expanded = !page.expanded;
    } else {
      this.menu.close();
      if (this.DEBUG) console.log('MENUE', this.menu);
      if (page.component && page.component != "") {
        event.preventDefault();
        event.stopPropagation();
        // close the menu when clicking a link from the menu

        if (page.command == 0) {
          if (page.component == "kalender") {
            this.navCtrl.navigateForward('/' + page.component);
          } else {
            this.navCtrl.navigateForward('/' + page.component, page.params);
          }
        } else if (page.command == 2) {
          this.goToRoot();
        } else if (page.command == 1) {

          this.presentAlert(
            this.translate.instant('logout.alert_confirm'),
            this.translate.instant('logout.alert_message'),
          );

        }
      }
    }
  }

  async presentAlert(headerstring, messagestring) {
    this.stringInButton = this.translate.instant('search.cancelBtn');
    this.stringInCode = this.translate.instant('logout.alert_confirm');
    const alert = await this.alertCtrl.create({
      header: headerstring,
      message: messagestring,
      buttons: [
        {
          text: this.stringInButton
        },
        {
          text: this.stringInCode,
          handler: () => {
            this.cp.accMngerPatient.logout().subscribe((message) => {
              this.logout();
              this.patislogin = false;
            });

          },
        },
      ],
    });
    await alert.present();
  }

  track(event: any) {
    // cookie banner was dismissed
    /*this.cookieLawSeen = event;*/
  }


  translateLanguageTo(lang: string) {
    this.translate.use(lang);
    AppSettings.setLanguage(lang);
    if (this.DEBUG) console.log('translate', this.translate);
    this.cp.setSelectedLanguage(AppSettings.getLanguage());
  }



  isBooking() {
    if (false) {
      if (this.DEBUG) console.log('this.router.url', this.router.url);
      let urlsplit = this.router.url.split('?');
      if (urlsplit[0] == '/buchen') {
        if (this.DEBUG) console.log(urlsplit);
        return false;
      }
      return true;
    }
  }

  dynamicTheme() {
    this.theme.activeTheme(this.selectTheme);
  }

  onToggleColorTheme(event) {
    //console.log(event.detail.checkbox);
    if (event.detail.checkbox) {
      document.body.setAttribute('color-theme', 'dark');
    }
    else {
      document.body.setAttribute('color-theme', "default");
    }

  }

  //Fingerprint-System

  public isLoggedin = false;
  public topnav = [
    {
      name: 'Produkte',
      marker: 'Produkte',
      active: false,
      icon: '',
      dropdown: [
        { name: 'TerMed Onlineterminierung', marker: 'produkt1', icon: 'assets/images/newDesign/TerMed_Icons_TerMed_Icons_Patient.svg', description: 'Lassen Sie Ihre Patienten schnell und unkompliziert online Termine vereinbaren' },
        { name: 'VIOMEDI', marker: 'produkt2', icon: 'assets/images/newDesign/TerMed_Icons_TerMed_Icons_Patient.svg', description: 'Nutzen Sie die fortschrittliche Praxis- Patientenkommunikation und bieten Sie damit zeitgemäße Services für Ihre Patienten' },
        { name: 'Hotline', marker: 'produkt3', icon: 'assets/images/newDesign/TerMed_Icons_TerMed_Icons_Patient.svg', description: 'Wir unterstützen Sie gerne durch Fachpersonal an Ihrer Telefonhotline.'},
      ]
    },
    {
      name: 'Über uns',
      marker: 'aboutus',
      active: false,
      icon: '',
      dropdown: [
        { name: 'Unser Team', marker: 'team', icon: 'assets/images/newDesign/TerMed_Icons_TerMed_Icons_Patient.svg', description: 'Dies ist die Beschreibung für TerMed Team' },
        { name: 'Unsere Geschichte', marker: 'geschichte', icon: 'assets/images/newDesign/TerMed_Icons_TerMed_Icons_Patient.svg', description: 'Dies ist die Beschreibung für Unsere Geschichte' }
      ]
    },
    { name: 'Karriere', marker: 'Karriere', active: false, icon: '' },
    { name: 'Kontakt', marker: 'Kontakt', active: false, icon: '' },
  ];


  checkDeviceWidth() {
    if (this.platform.width() < 800) {
      this.isMobile = true;
    } else {
      this.isDesktop = true;
    }
  }


  navigateToPage(marker: string) {
    //console.log('navigateToPage marker', marker);
    if (marker === 'Karriere') {
      this.router.navigate(['/karriere']);
    }
    if (marker === 'aboutus') {
      this.router.navigate(['/about']);
    }
    if (marker === 'Produkte') {
      this.router.navigate(['/products']);
    }
    if (marker === 'produkt1') {
      this.router.navigate(['/reserve'])
    }
    if (marker === 'produkt2') {
      this.router.navigate(['/access']);
    }
    if (marker === 'produkt3') {
      this.router.navigate(['/connect']);
    }
    if (marker === 'team') {
      this.router.navigate(['/about'], { fragment: 'team' }).then(() => {
        this.scrollToFragment('team');
      });
    } else if (marker === 'geschichte') {
      this.router.navigate(['/about'], { fragment: 'mission' }).then(() => {
        this.scrollToFragment('mission');
      });
    }

    if (marker === 'Kontakt') {
      this.router.navigate(['/contact']);
    }
    this.menu.close();
  }


  navigateToHome() {
    this.router.navigate(['/termedinfo']);
    this.menu.close();
  }

  navigateToLogin() {
    this.router.navigate(['/login']);
    this.menu.close();
  }


  scrollToFragment(fragment: string) {
    const element = document.getElementById(fragment);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  protected readonly environment = environment;

  docUrl = environment.docUrl;
  public toDoc() {
    window.open(this.docUrl);
  }



  closeStartMenu() {
    /**
     * Open the menu by menu-id
     * We refer to the menu using an ID
     * because multiple "start" menus exist.
     */
    this.menu.close('first-menu');
  }



  openLink(url){
    window.open(url, '_blank', 'location=yes');
  }





}

